import CloseIcon from 'components/common/CloseIcon'
import Modal, { ModalRef } from 'components/common/Modal/Modal'
import OrderProgress from 'components/common/OrderProgress/OrderProgress'
import React, { forwardRef } from 'react'
import s from './OrderProgressModal.module.css'

type Props = {}

const OrderProgressModal = forwardRef<ModalRef, Props>(({}, ref) => {
  return (
    <Modal
      className={s.orderProgressModal}
      ref={ref}
      headerActive={false}
      overflowContent
    >
      <div className="static mx-auto h-full w-full overflow-hidden">
        <OrderProgress />
      </div>
      <div
        className="absolute -top-16 right-2 flex cursor-pointer items-center justify-center rounded-md p-2 hover:bg-black/60 sm:-right-1"
        onClick={() => ref.current!.closeModal()}
      >
        <CloseIcon className="h-8 w-8 fill-white" />
      </div>
    </Modal>
  )
})

export default OrderProgressModal
